package com.eladfinish.bible.contest.screens.main.data

import io.github.aakira.napier.Napier
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList
import kotlinx.serialization.KSerializer
import kotlinx.serialization.Serializable
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

// TODO: renaming members should be done carefully!!!
@Serializable(with = ButtonTypeSerializer::class)
enum class ButtonType(val isPublic: Boolean = true) {
    NAMES,
    RANDOM_VERSE,
    VERSE_WIDGET, // "ווידג'ט פסוק מתחלף": the settings screen of the home-screen widget (Android and iOS only)
    COMPLETE_VERSE,
    SEARCH,
    COMPLETE_CHAPTER,
    PAIR_MATCHING,
    MULTIPLE_CHOICE_QUESTIONS,
    PYRAMID_CROSSWORD,
    OPEN_QUESTIONS,
    BROWSE,
    MIKUD,
    RECORDINGS,
    TELEGRAM_CHANNEL,
    LEXICOGRAPHICAL_SORT,
    PAST_QUIZZES, // "חידונים אמיתיים": the district-quiz web app's exam mode in a WebView; was DISTRICT_QUIZ_EXAM
    SETTINGS,
    MISC, // was LIST_OF_WINNERS
    ABOUT,
    HELP,
    REORDER,
    EXIT,
    UNKNOWN,
}

fun List<ButtonType>.toButtonDataList(): ImmutableList<Pair<ButtonType, ButtonData>> =
    this.map { it.toButtonData() }.toImmutableList()

object ButtonTypeSerializer : KSerializer<ButtonType> {
    override val descriptor: SerialDescriptor = PrimitiveSerialDescriptor(serialName = "ButtonType", kind = PrimitiveKind.STRING)

    override fun serialize(encoder: Encoder, value: ButtonType) {
        encoder.encodeString(value.name.lowercase())
    }

    override fun deserialize(decoder: Decoder): ButtonType {
        val value = decoder.decodeString().uppercase()
        // Renamed members, kept in their place in a saved button order.
        if (value == "DISTRICT_QUIZ_EXAM") return ButtonType.PAST_QUIZZES // test builds 210/211
        return try {
            ButtonType.valueOf(value)
        } catch (e: IllegalArgumentException) {
            Napier.e("deserialize ButtonType error: $e")
            when (value) {
                "LIST_OF_WINNERS",
                "LETTERS_PUZZLE",
                "EXPRESSIONS",
                "PERSONAL_LIST",
                "SEARCH_CMP",
                    -> {
                    ButtonType.UNKNOWN
                }

                else -> {
                    throw IllegalArgumentException("Unknown button type: $value")
                }
            }
        }
    }
}
